/**
 * Вспомогательные утилиты и кроссбраузерные полифиллы
 * @module helpers
 * @memberOf module:layout
 */

/**
 * Назначить обработчик событий DOM-элементу
 * @param {HTMLElement} el DOM элемент
 * @param {string} eventName название события (без префикса "on")
 * @param {function} eventHandler обработчик
 */
function bindEvent(el, eventName, eventHandler) {
    if (el.addEventListener) {
        el.addEventListener(eventName, eventHandler, false);
    }
    else if (el.attachEvent) {
        el.attachEvent('on' + eventName.toLowerCase(), eventHandler);
    }
}

/**
 * Удалить обработчик событий у DOM-элемента
 * @param {HTMLElement} el DOM элемент
 * @param {string} eventName название события (без префикса "on")
 * @param {function} eventHandler обработчик
 */
function unbindEvent(el, eventName, eventHandler) {
    if (el.removeEventListener) {
        el.removeEventListener(eventName, eventHandler, false);
    }
    else if (el.detachEvent) {
        el.detachEvent('on' + eventName, eventHandler);
    }
}

/**
 * @description Превент любого бразурного события
 * @param {Event} e Событие
 */
function preventEvent(e) {
    e.preventDefault();
    e.stopPropagation();
    e.cancelBubble = true;
    e.returnValue = false;
    return false;
}

/**
 * Получение абсолютной позиции левого верхнего угла DOM-элемента
 * @param {HTMLElement} element ссылка на DOM-элемент
 * @returns {{x:0, y:0}} координаты
 */
function getElementPosition(element) {
    let el = element, result = {x: 0, y: 0};
    while (el) {
        result.x += el.offsetLeft || 0;
        result.y += el.offsetTop || 0;
        el = el.offsetParent;
    }
    return result;
}

/**
 * Определение координат мыши относительно объекта
 * @param {Event} event событие браузера
 * @param {HTMLElement} [element] ссылка на DOM-элемент, относительно которого необходимо получить координаты
 * @returns {{x:number, y:number}} координаты
 */
function getPointerCoordinates(event, element) {
    let e = event || window.event,
        ret = getElementPosition(element);

    e = (e && e.touches && e.touches[0]) || e;
    if (e) {

        let x = 0, y = 0;
        if (('pageX' in e) && ('pageY' in e)) {
            x = e.pageX;
            y = e.pageY;
        }
        else if (('clientX' in e) && ('clientY' in e)) {
            x = e.clientX + (document.documentElement.scrollLeft || document.body.scrollLeft) - document.documentElement.clientLeft;
            y = e.clientY + (document.documentElement.scrollTop || document.body.scrollTop) - document.documentElement.clientTop;
        }
        ret.x = x - ret.x;
        ret.y = y - ret.y;
    }
    return ret;

}

export { bindEvent, unbindEvent, preventEvent, getElementPosition, getPointerCoordinates }